/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The text ratio calculation to be updated.
 */
export enum UserSettingsUiTextRatioCalculation {
    USE_NEW_SUBS_REVENUE = 'UseNewSubsRevenue',
    USE_ALL_SUBS_REVENUE = 'UseAllSubsRevenue',
}
